const viewRecord = {
  state: {
    search_value: '',
    import_record_headers: [
      { text: 'Open ID', value: 'open_id' },
      { text: 'MemberGTLCode', value: 'MemberGTLCode' },
      { text: 'FamilyGTLCode', value: 'FamilyGTLCode' },
      { text: 'AgentGTLCode', value: 'AgentGTLCode' },
      { text: 'Display Name', value: 'display_name' },
      { text: 'MemberEmailID', value: 'MemberEmailID' },
      { text: 'Total Report', value: 'total_report' },
      { text: 'Counter', value: 'counter' },
      { text: 'Last Open Date', value: 'last_open_date' }
    ],
    user_header: [
      { text: 'Client ID', value: 'client_id' },
      { text: 'MemberGTLCode', value: 'MemberGTLCode' },
      { text: 'FamilyGTLCode', value: 'FamilyGTLCode' },
      { text: 'AgentGTLCode', value: 'AgentGTLCode' },
      { text: 'Display Name', value: 'display_name' },
      { text: 'Last Name', value: 'last_name' },
      { text: 'First Name', value: 'first_name' },
      { text: 'Contact Email', value: 'contact_email' },
      { text: 'Mobile Number', value: 'mobile_number' },
      { text: 'wechatID', value: 'wechatID' },
      { text: 'Address', value: 'address' },
      { text: 'Dob', value: 'dob' },
      { text: 'Gender', value: 'gender' },
      { text: 'Nationality', value: 'nationality' },
      { text: 'Race', value: 'race' },
      { text: 'Weight', value: 'weight' },
      { text: 'Race', value: 'race' },
      { text: 'Address', value: 'address' },
      { text: 'Edit', value: 'edit' },
      { text: 'Delete', value: 'delete' }
    ],
    report_header: [
      { text: 'SalesGTLCode', value: 'SalesGTLCode' },
      { text: 'Open ID', value: 'open_id' },
      { text: 'Client ID', value: 'client_id' },
      { text: 'Essential ID', value: 'essential_id' },
      { text: 'Report Name', value: 'report_name' },
      { text: 'Download', value: 'download' },
      { text: 'Delete', value: 'delete' }
    ],
    items: [
      {
        display_name: '陳大文',
        open_id: '0nwNvfeU4jVuDVKfkD5F',
        display_lang: 'English',
        memberGTLCode: 30001027,
        agentGTLcode: 20001008,
        total_report: 1,
        counter: 12,
        last_open_date: '2019/03/16'
      }
    ],
    users_items: [
      {
        client_id: '',
        display_name: '',
        first_name: '',
        last_name: '',
        wechatID: '',
        mobile_number: '',
        contact_email: '',
        address: '',
        dob: '',
        gender: '',
        nationality: '',
        race: '',
        weight: '',
        display_lang: ''
      }
    ],
    report_items: [
      {
        essential_id: '',
        open_id: '',
        client_id: '',
        report_name: '',
        report: '',
        SalesGTLCode: '',
        edit: '',
        delete: ''
      }
    ],
    asyn_data: ''
  },
  mutations: {
    setViewRecordItem (state: any, payload: any) {
      state.items = payload
    },
    setUsersItem (state: any, payload: any) {
      state.users_items = payload
    },
    setReportItem (state: any, payload: any) {
      state.report_items = payload
    }
  }
}

export default viewRecord
